(() => {
  if (window.__omMobileStickyCheckoutInitialized) {
    return;
  }

  window.__omMobileStickyCheckoutInitialized = true;

  const MOBILE_QUERY = '(max-width: 749px)';

  const CHECKOUT_SELECTOR = [
    '#main-cart-footer .cart__checkout-button',
    '#main-cart-footer button[name="checkout"]',
    '#main-cart-footer input[name="checkout"]'
  ].join(', ');

  let stickyBar = null;
  let stickyTotal = null;
  let nativeCheckoutObserver = null;
  let nativeCheckoutVisible = false;
  let cartHasItems = false;
  let refreshTimer = null;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getNativeCheckoutButton() {
    return Array.from(
      document.querySelectorAll(CHECKOUT_SELECTOR)
    ).find((button) => {
      return !button.closest(
        '[data-om-mobile-sticky-checkout]'
      );
    }) || null;
  }

  function formatMoney(paise) {
    const rupees = Number(paise || 0) / 100;

    return `Rs. ${new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(rupees)}`;
  }

  function createStickyBar() {
    stickyBar = document.querySelector(
      '[data-om-mobile-sticky-checkout]'
    );

    if (stickyBar) {
      stickyTotal = stickyBar.querySelector(
        '[data-om-mobile-sticky-total]'
      );

      return stickyBar;
    }

    stickyBar = document.createElement('div');

    stickyBar.className =
      'om-mobile-sticky-checkout';

    stickyBar.setAttribute(
      'data-om-mobile-sticky-checkout',
      ''
    );

    stickyBar.setAttribute(
      'aria-hidden',
      'true'
    );

    stickyBar.innerHTML = `
      <div class="om-mobile-sticky-checkout__summary">
        <span class="om-mobile-sticky-checkout__label">
          Cart Total
        </span>

        <strong
          class="om-mobile-sticky-checkout__total"
          data-om-mobile-sticky-total
        >
          Rs. 0.00
        </strong>
      </div>

      <button
        type="button"
        class="om-mobile-sticky-checkout__button"
        data-om-mobile-sticky-trigger
      >
        Checkout
      </button>
    `;

    document.body.appendChild(stickyBar);

    stickyTotal = stickyBar.querySelector(
      '[data-om-mobile-sticky-total]'
    );

    const stickyButton = stickyBar.querySelector(
      '[data-om-mobile-sticky-trigger]'
    );

    stickyButton.addEventListener('click', () => {
      const nativeCheckout =
        getNativeCheckoutButton();

      if (
        !nativeCheckout ||
        nativeCheckout.disabled ||
        nativeCheckout.getAttribute(
          'aria-disabled'
        ) === 'true'
      ) {
        return;
      }

      /*
        Click the original checkout button so Shopflo and
        any existing checkout logic continue working.
      */
      nativeCheckout.click();
    });

    return stickyBar;
  }

  function updateVisibility() {
    if (!stickyBar) {
      return;
    }

    const shouldShow =
      isMobile() &&
      cartHasItems &&
      !nativeCheckoutVisible;

    stickyBar.classList.toggle(
      'is-visible',
      shouldShow
    );

    stickyBar.setAttribute(
      'aria-hidden',
      shouldShow ? 'false' : 'true'
    );

    document.body.classList.toggle(
      'om-cart-mobile-sticky-active',
      isMobile() && cartHasItems
    );
  }

  function observeNativeCheckout() {
    if (nativeCheckoutObserver) {
      nativeCheckoutObserver.disconnect();
    }

    const nativeCheckout =
      getNativeCheckoutButton();

    if (!nativeCheckout) {
      nativeCheckoutVisible = false;
      updateVisibility();
      return;
    }

    nativeCheckoutObserver =
      new IntersectionObserver(
        (entries) => {
          const entry = entries[0];

          nativeCheckoutVisible =
            Boolean(
              entry &&
              entry.isIntersecting &&
              entry.intersectionRatio > 0.15
            );

          updateVisibility();
        },
        {
          threshold: [0, 0.15, 0.5, 1]
        }
      );

    nativeCheckoutObserver.observe(
      nativeCheckout
    );
  }

  async function fetchCart() {
    const root =
      window.Shopify?.routes?.root || '/';

    const response = await fetch(
      `${root}cart.js`,
      {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }
    );

    if (!response.ok) {
      throw new Error(
        'Unable to retrieve cart.'
      );
    }

    return response.json();
  }

  async function refreshStickyBar() {
    try {
      const cart = await fetchCart();

      createStickyBar();

      cartHasItems =
        Number(cart.item_count || 0) > 0;

      if (stickyTotal) {
        stickyTotal.textContent =
          formatMoney(cart.total_price);
      }

      observeNativeCheckout();
      updateVisibility();
    } catch (error) {
      console.error(
        'OM Mobile Sticky Checkout:',
        error
      );
    }
  }

  function scheduleRefresh(delay = 400) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(
      refreshStickyBar,
      delay
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      createStickyBar();
      scheduleRefresh(50);
    }
  );

  document.addEventListener(
    'cart:updated',
    () => scheduleRefresh(100)
  );

  document.addEventListener(
    'change',
    (event) => {
      if (
        event.target.matches(
          '[name="updates[]"], .quantity__input'
        )
      ) {
        scheduleRefresh(800);
      }
    }
  );

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target.closest(
          'quantity-input, ' +
          'cart-remove-button, ' +
          '.quantity__button, ' +
          '[data-essential-upsell-element="add-to-cart-button"]'
        )
      ) {
        scheduleRefresh(900);
      }
    }
  );

  window.addEventListener(
    'resize',
    () => {
      observeNativeCheckout();
      updateVisibility();
    }
  );

  const mutationObserver =
    new MutationObserver(() => {
      scheduleRefresh(500);
    });

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const cartArea =
        document.querySelector('cart-items') ||
        document.querySelector('#MainContent');

      if (cartArea) {
        mutationObserver.observe(cartArea, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }
  );
})();